import { EMPTY_FUNCTION } from '../../../../constants/common'
import { PDF_VIEWER_THUMBNAIL_WIDTH } from '../PdfViewerThumbnails.constants'

export function renderPdfViewerThumbnail({ canvas, page, rotation }) {
  // `rotation` on getViewport is absolute, so the page's own /Rotate is added
  const totalRotation = page.rotate + rotation
  const baseViewport = page.getViewport({ rotation: totalRotation, scale: 1 })
  const outputScale = window.devicePixelRatio || 1
  const viewport = page.getViewport({
    rotation: totalRotation,
    scale: PDF_VIEWER_THUMBNAIL_WIDTH / baseViewport.width,
  })

  canvas.width = Math.floor(viewport.width * outputScale)
  canvas.height = Math.floor(viewport.height * outputScale)

  const renderTask = page.render({
    canvas,
    transform:
      outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null,
    viewport,
  })

  renderTask.promise.catch(EMPTY_FUNCTION)

  return renderTask
}
